export default "__VITE_ASSET__B6LyGS41__"